import React, { Fragment } from "react";
import SettingAsideLeft from "../partials/SettingAsideLeft";

const Appearance = () => {
  return (
    <Fragment>
      <SettingAsideLeft />
      Appearance
    </Fragment>
  );
};

export default Appearance;
